<template>
  <div class="v-button-component" :style="buttonComponentStyle" :class="{ small, cancel }">
    <button class="v-button" ref="button" :style="buttonStyle" :class="color" @click="$emit('click')">
      <div class="v-button-icon" :style="iconStyle" v-if="icon" />
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    shadow: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    padding: {
      type: String,
    },
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: '15'
    },
    height: {
      type: String,
      default: '40'
    },
    focus: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    buttonComponentStyle() {
      return {
        height: `${this.height}px`,
      }
    },
    buttonStyle() {
      return {
        padding: this.padding,
        boxShadow: this.shadow ? '0 2px 8px rgba(0, 0, 0, 0.2)' : 'none',
        fontSize: `${this.fontSize}px`,
        fontWeight: this.bold ? 'bold' : 'normal'
      }
    },
    iconStyle() {
      return {
        background: this.icon ? `url(${require('@/assets/images/' + this.icon + '.svg')}) no-repeat center / 100% auto` : 'none'
      }
    }
  },
  mounted() {
    if (this.focus) {
      this.$refs.button.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.v-button-component {
  &.cancel {
    .v-button {
      background-color: #f1f2f3;
      color: #666;
      &:hover {
        background-color: #ddd;
      }
    }
  }
  &.upload {
    height: 50px;
    .v-button {
      padding: 0 40px;
      font-size: 17px;
    }
  }
  &.small {
    height: 30px !important;
    .v-button {
      min-width: initial;
      padding: 0 12px;
      font-size: 13px !important;
    }
  }
  &.xs {
    height: 20px !important;
    .v-button {
      min-width: initial;
      padding: 0 6px;
      font-size: 11px !important;
    }
  }
  &.red {
    .v-button {
      background-color: #e05;
      &:hover {
        background-color: #f05;
      }
    }
  }
  &.absolute {
    position: absolute;
  }
  &.top {
    top: 0;
  }
  &.right {
    right: 0;
  }
  &.group {
    .v-button {
      background-color: #4bbbc0;
      &:hover {
        background-color: #29bbc0;
      }
    }
  }
}
.v-button {
  min-width: 100px;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  padding: 0 16px;
  background-color: $mainColor;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 15px;
  color: #fff;
  transition: 0.1s ease-out;
  white-space: nowrap;
  &.green {
    background-color: #217346;
    &:hover {
      background-color: #004B1C;
    }
  }
  &:hover {
    background-color: $subColor;
  }
}
.v-button-icon {
  width: 16px;
  height: 100%;
  margin-right: 4px;
}
</style>
